import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export const ApproveIcon = ({
  size = 24,
  sx,
  color,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke={iconColor}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="m4 11.693 5.538 5.538L20 6.77"
      />
    </Box>
  );
};
